// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import validateLoss from './validateLoss'

// dynamically takes the loss field's name and assigns an error message
// if its value failed validation.
const validateLossField = (v, err, k) => {
  const msg = validateLoss(v)

  if (msg) {
    err[k] = msg
  }

  return err
}

export default validateLossField
